import { Box, Heading, Text } from '@wix/design-system';
import { useLocalization } from '@wix/package-picker-shared-studio';
import * as React from 'react';
import AfnicLogo from '../../assets/afnic-logo.svg';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import styles from './AfnicTrustBuilder.scss';

export const AfnicTrustBuilder: React.FC = () => {
  const { shouldShowFrenchExperience } = useLocalization();
  const { t } = StudioPackagePickerModule.internals.useTranslations();

  if (!shouldShowFrenchExperience) {
    return null;
  }

  return (
    <Box
      direction="vertical"
      align="center"
      borderTop="1px solid var(--studio-content-border-color, #DFE5EB)"
      borderBottom="1px solid var(--studio-content-border-color, #DFE5EB)"
      padding="36px 0"
      dataHook="afnic-recommended"
      width="100%"
    >
      <Box marginBottom="18px" width="111px" height="111px">
        <AfnicLogo />
      </Box>
      <Box marginBottom="12px" fontWeight="700">
        <Heading appearance="H3" className={styles.afnicHeading}>
          {t('Advanced.Features_Values_Afnic_FR_PP_header')}
        </Heading>
      </Box>
      <Box width="590px">
        <Text size="medium" align="center">
          {t('Advanced.Features_Values_Afnic_FR_PP_subheader')}
        </Text>
      </Box>
    </Box>
  );
};
